import { render } from "./ProfileEdit.vue?vue&type=template&id=3cb84594&scoped=true"
import script from "./ProfileEdit.vue?vue&type=script&lang=ts"
export * from "./ProfileEdit.vue?vue&type=script&lang=ts"

import "./ProfileEdit.vue?vue&type=style&index=0&id=3cb84594&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3cb84594"

export default script